import axios from "axios";
import { getBasicAuthHeadersElastic, getAuthHeaders } from "../Helpers";

/**
 * @function getBasicSpecialities
 * @returns Promise
 * @description Get Basic specialities
 */
export const getBasicSpecialities = (name) => {
  let url = `${process.env.REACT_APP_ELASTIC_BASE_URL}/${process.env.REACT_APP_CLINIC_SPECIALITIES_INDEX}/_search`;
  const params = {
    query: {
      bool: {
        must: [],
      },
    },
    from: 0,
    size: 50,
  };
  if (name) {
    params.query.bool.must.push({
      match_phrase_prefix: { name: name },
    });
  }

  return axios.post(url, params);
};


/**
 * @function getNewsArticles
 * @desc Gets news articles
 */
export const getNewsArticles = (pageNo, perPage, filterParams) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/doctors/news_articles/list_news?page=${pageNo}&perpage=${perPage}`;
  if (filterParams?.specIds) {
    url = `${url}&basic_speciality_ids=${filterParams?.specIds}`;
  }
  if (filterParams && filterParams.type) {
    url = `${url}&news_type=${filterParams?.type}`;
  }

  return axios.get(url);
};

/**
 * @function getNewsArticlesDetails
 * @desc Gets news articles
 */
export const getNewsArticlesDetails = (articleId) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/doctors/news_articles/${articleId}`;

  return axios.get(url);
};

/**
 * @function subscribeToNews
 * @desc Gets news articles
 */
export const subscribeToNews = (params) => {
  let url = `${process.env.REACT_APP_SERVER_URL}/mailing_list_items`;
  return axios.post(url, params);
};

/**
 * @function getUserProfile
 * @desc gets user's profile
 */
export const getUserProfile = () =>
  axios.get(`${process.env.REACT_APP_SERVER_URL}/users/profile`, {
    headers: getAuthHeaders(),
  });

/**
 * @function refreshToken
 * @desc This service refreshed token
 */
export const refreshToken = (params) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/auth/refresh`;
  return axios.post(url, params);
};
